import React, { useState } from "react";
import { FaArrowRight, FaSearch } from "react-icons/fa";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  CardBody,
  Col,
  Input,
  InputGroup,
  InputGroupText,
  Row,
} from "reactstrap";
import Link from "next/link";
import Image from "next/image";

//local imports
import classes from "@/styles/info/connect-tools-main.module.css";
import { shipvistaForPlatforms } from "@/utils/content";
import data from "@/data/connect-tools.json";
import { routes } from "@/utils/routes";
import { useIsMobile } from "@/hooks/useIsMobile";

export default function ConnectToolsMain() {
  const content = shipvistaForPlatforms.en;

  const [ct, setCt] = useState<any>(data);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState<string>("1");
  const isMobile = useIsMobile();

  //@ts-ignore
  const toggle = (id) => {
    if (open === id) {
      //@ts-ignore
      setOpen();
    } else {
      setOpen(id);
    }
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setSearch(e.target.value);
    const text = e.target.value.split(" ");
    if (e.target.value.length === 0) {
      setSearch("");
      setCt(data);
    } else {
      setSearch(e.target.value);
      const newCt = data.filter((i) => {
        return text.every((el: any) => {
          return i.name.toLowerCase().includes(el);
        });
      });
      setCt(newCt);
    }
  };

  return (
    <div className={classes.container}>
      <section className="text-center my-5 container">
        <h1 className="fw-bold">{content.title}</h1>
        <h2 className="mt-4">{content.title2}</h2>
        <p className="mt-3">{content.para2}</p>
        <InputGroup className={classes.inputGroup}>
          <Input
            className={classes.input}
            type="search"
            placeholder={content.search}
            onChange={onChange}
            value={search}
          />
          <InputGroupText className={classes.inputGroupText}>
            <FaSearch />
          </InputGroupText>
        </InputGroup>
      </section>
      <section className="my-5 container">
        <h3 className={classes.featured}>{content.featured}</h3>
        <Row className={`my-5 mx-auto ${isMobile ? "" : "w-75"}`}>
          {ct?.map((t: any, i: number) => (
            <Col xs={12} className="mb-3" md={4} key={i}>
              <Link
                className={classes.wrapperLink}
                href={
                  t.slug
                    ? `${routes.connectTools}/${t.slug}`
                    : routes.connectTools
                }
              >
                <Card className={classes.featureCard}>
                  <div
                    className={classes.cardHeader}
                    style={{ background: t.color }}
                  >
                    {t.type}
                  </div>
                  <Image
                    className={`img-fluid ${classes.cardImg}`}
                    src={t.logoPath}
                    alt={t.name}
                    height={1500}
                    width={3000}
                  />
                  <CardBody className={classes.cardBody}>
                    <h6>{t.name}</h6>
                    <p>{t.title}</p>
                  </CardBody>
                  {t.slug && (
                    <span className={classes.link}>
                      Learn More <FaArrowRight className={classes.arrow} />
                    </span>
                  )}
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
      </section>
      <section className="my-5 container">
        <h2 className={classes.h2}>{content.faqsTitle}</h2>
        <Accordion
          className="my-4"
          open={open}
          //@ts-ignore
          toggle={toggle}
        >
          <Row>
            {content.faqs.map((f, i) => (
              <Col xs={12} lg={6} key={i}>
                <AccordionItem>
                  <AccordionHeader targetId={(i + 1).toString()}>
                    {f.title}
                  </AccordionHeader>
                  <AccordionBody accordionId={(i + 1).toString()}>
                    <p>{f.desc}</p>
                  </AccordionBody>
                </AccordionItem>
              </Col>
            ))}
          </Row>
        </Accordion>
      </section>
      <section className={classes.footer}>
        <p>
          {content.footerPara}&nbsp;
          <a href={`mailto:${content.email}`}>{content.email}</a>
        </p>
      </section>
    </div>
  );
}
